import api from '@/utils/http'

/**
 功能：列表
 time: 2025-13-01 17:13:44
 **/
export function getCompanyBusinessList(data) {
    return api.post('/admin/companyBusiness/getList', data)
}

/**
 功能：保存
 time: 2025-38-02 16:38:38
 **/
export function saveCompanyBusiness(data) {
    return api.post('/admin/companyBusiness/eSave', data)
}

/**
 功能：
 time: 2025-42-02 16:42:10
 **/
export function getCompanyBusinessDetail(b_id) {
    return api.post('/admin/companyBusiness/getDetail', { b_id })
}

/**
 功能：
 time: 2025-20-02 17:20:52
 **/
export function deleteCompanyBusiness(b_id) {
    return api.post('/admin/companyBusiness/del', {b_id})
}

/**
 功能：
 time: 2025-48-03 09:48:06
 **/
export function deleteAllCompanyBusiness(bIds) {
    return api.post('/admin/companyBusiness/delAll', {bIds})
}

/**
 功能：下拉
 time: 2025-49-03 09:49:03
 **/
export function selectCompanyBusinessList() {
    return api.get('/admin/companyBusiness/getSelectList')
}

